module.exports = __webpack_public_path__ + "static/img/3-4.bf3232d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-3/3-4.jpg
// module id = 739
// module chunks = 1